module.exports = __webpack_public_path__ + "static/media/007-nicaragua.368d2973.svg";